/**
 * Conversation builder page views
 */
define(function (require) {
    "use strict";

    var template = require("automation-templates/convbuilder.tmpl");
    var ConvBuilderView = {};

    LE.module('LEAutomation', function (LEAutomation, LE, Backbone, Marionette, $, _) {
        ConvBuilderView = Marionette.ItemView.extend({
            template: template,
            className: 'automation-conversation-builder',
            ui: {
                conversationbuilder_iframe: "#conversationbuilder-iframe"
            },

            initialize: function (options) {
                this.$el = options.el;
            },

            onRender: function () {
                $(this.$el).append(this.el);
                LEAutomation.contextModel.set('conversationbuilder-iframe', this.ui.conversationbuilder_iframe);
            },
        });
    });

    return ConvBuilderView;
});
